import React, { HTMLAttributeAnchorTarget } from 'react';

import type { RouterProps } from '../../internal/types/routerTypes';
import { Link, LinkColor } from '../Link';

/**
 * Функция, оборачивающая текст в компонент Link с заданными параметрами
 * @param {String | undefined} text  текст ссылки
 * @param {LinkColor} color  цвет ссылки
 * @param {String} href  адрес ссылки
 * @param {void} onClick  обработчик нажатия на ссылку
 * @param {RouterOptions} routerOptions  опции роутера
 * @returns {JSX.Element | null} компонент Link с заднными параметрами, содержащий внутри себя текст
 */
export const wrapWithLink = ({
    text,
    color,
    href,
    target,
    routerOptions,
    onClick,
}: RouterProps & {
    text: string | undefined;
    color: LinkColor;
    href?: string;
    target?: HTMLAttributeAnchorTarget;
    onClick?: () => void;
}) => {
    if (!text) {
        return null;
    }

    return (
        <Link
            color={color}
            href={href}
            target={target}
            routerOptions={routerOptions}
            onClick={href ? undefined : onClick}
        >
            {text}
        </Link>
    );
};
